import React, { useEffect, useState } from "react"; 
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from "react-router-dom";
import "swiper/css"
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/autoplay"; // optional, just for clarity
import { Navigation, Pagination, Autoplay } from "swiper/modules"; 
  const HotPropertyHome = ({offertype, typ}) => {  
    const [listings, setListings] = useState([]);
     const [loading, setLoading] = useState(true);
  const API =  process.env.REACT_APP_API_URL || "https://nvrealestate.websiteseoonline.com";
 
     useEffect(() => {
     fetch(`${API}/api/hotpropertylisting.ashx`, { 
         method: "POST",
         headers: {
           "Content-Type": "application/json"
         },
         body: JSON.stringify({ offertype,typ })
       }) // 🔁 replace URL
         .then((res) => res.json())
         .then((res) => {
           console.log("API Response:", res);
   
           // ✅ Handle different API formats safely
           const result = Array.isArray(res) ? res : res.data;
   
           setListings(result || []);
           setLoading(false);
         })
         .catch((err) => {
           console.error("API Error:", err);
           listings([]);
           setLoading(false);
         });
     },  [offertype,typ]);
  
    if (loading) return <p>Loading properties...</p>;
  
  return (
    <div className="wrap-categories-sw wow fadeInUp" data-wow-delay=".2s">
      <Swiper
        spaceBetween={30}
        slidesPerView={6}
        modules={[Navigation, Pagination,Autoplay]} 
        //navigation               // ✅ arrows
        pagination={{ clickable: true }}  // ✅ dots
         autoplay={{
          delay: 3000, // 3 seconds
          disableOnInteraction: false, // continue autoplay after user interaction
        }}
        breakpoints={{
          320: { slidesPerView: 1, spaceBetween: 15 },
          640: { slidesPerView: 3, spaceBetween: 15 },
          768: { slidesPerView: 3, spaceBetween: 30 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        }}
        className="tf-sw-categories"
      >
       {listings.map(item => (
       <SwiperSlide>
       <div className="homelengo-box">
                <div className="archive-top">
                <Link className="images-group" to={`/property/${item.url}`}>
                     <div className="images-style">
                     <img src={item.ImagePath+'/w=421,sharpen=1'} alt={item.title}  className=" ls-is-cached lazyloaded" />
                    </div>
                    <div className="top">
                      <ul className="d-flex gap-6">
                        <li className="flag-tag primary">{item.property_type}</li>
                        <li className="flag-tag style-1">For {item.offering_type}</li>
                      </ul>
                    </div>
                  </Link>
                </div>
                <div className="archive-bottom">
                  <div className="content-top">
                    <h6 className="text-capitalize">
                      <Link className="link" to={`/property/${item.url}`}>
                        {item.title}
                      </Link>
                    </h6>
                    <p>
                      <svg
                        width={16}
                        height={16}
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M10 7C10 7.53043 9.78929 8.03914 9.41421 8.41421C9.03914 8.78929 8.53043 9 8 9C7.46957 9 6.96086 8.78929 6.58579 8.41421C6.21071 8.03914 6 7.53043 6 7C6 6.46957 6.21071 5.96086 6.58579 5.58579C6.96086 5.21071 7.46957 5 8 5C8.53043 5 9.03914 5.21071 9.41421 5.58579C9.78929 5.96086 10 6.46957 10 7Z"
                          stroke="#000"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M13 7C13 11.7613 8 14.5 8 14.5C8 14.5 3 11.7613 3 7C3 5.67392 3.52678 4.40215 4.46447 3.46447C5.40215 2.52678 6.67392 2 8 2C9.32608 2 10.5979 2.52678 11.5355 3.46447C12.4732 4.40215 13 5.67392 13 7Z"
                          stroke="#000"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {item.sub_community}, {item.community}, {item.city}
                    </p>
                      <ul className="meta-list">
                     {item.rsco === "Residential" && (
    <>
      <li className="item">
        <i className="fa-solid fa-bed" />{" "}
        <strong>
          {Number(item.bedrooms) === 0 ? "Studio" : item.bedrooms}
        </strong>
      </li>

      <li className="item">
        <i className="fa-solid fa-bath" />{" "}
        <strong>{item.No_of_Bathroom}</strong>
      </li>
        <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
    </>
  )}

  {item.rsco === "Commercial" && (
    <li className="item">
      <i className="fa-solid fa-ruler-combined" />{" "}
      <strong>{Number(item.size).toLocaleString()} SQFT</strong>
    </li>
  )}
                        </ul>
                        <p className="pt-10">Property ID: {item.reference_number}</p>
                   
                  </div>
                  <div className="content-bottom">
                    <h6 className="price">AED {Number(item.price).toLocaleString()}</h6>
                  </div>
                 <div className="listing-card">
                                          <img src={item.agent_img+"/w=60,sharpen=1"} alt="Agent" className="agent-img" />
                                          <div className="text-content">
                                            <div className="listing-by">Listing by</div>
                                            <div className="agent-name">{item.agent_name}</div>
                                          </div>
                                        </div>
                                        <div className="content-bottom1">
                                                                <div className="property-icns-w">
                                                                  <Link to={`tel:${item.agent_phone}`}>
                                                                    <i className="icon">
                                                                      <img src="images/img/phone.svg" alt="Call" />
                                                                    </i>
                                                                    Call
                                                                  </Link>
                                                                  <Link
                                                                    to={`https://web.whatsapp.com/send?phone=${item.agent_whatsapp}&text=Hi, I am interested in the listing, ${item.title}, from your website.`}
                                                                    target="_blank"
                                                                  >
                                                                    <i className="icon">
                                                                      <img src="images/img/whatsapp.svg" alt="Whatsapp" />
                                                                    </i>
                                                                    Whatsapp
                                                                  </Link>
                                                                </div>
                                        </div>
                </div>
              </div>
  </SwiperSlide>
    ))}
        {/* Add other SwiperSlide components here */}
      </Swiper>
    </div>
  );
}

export default HotPropertyHome;
